import React from 'react';
import { Button, ButtonSize, ButtonType } from 'common/button';
import { RouteName, goToPage } from 'routes';
import { classnames } from 'helpers/utils';
import successCheck from 'assets/lottie/successCheck.json';
import Lottie from 'lottie-react';
import styles from './reset-password-step.module.scss';

const ResetPasswordStep2: React.FC = () => {
  const showContentView = () => (
    <>
      <Lottie
        animationData={successCheck}
        className={styles.lottie}
        loop={false}
      />
      <div className={styles.containerTitleStep2}>
        <div className={classnames(styles.title, 'text__title1__gray800')}>
          Your new password has been created.
        </div>
        <div
          className={classnames(
            'text__body__regular__medium__gray700',
            'mb-12',
          )}
        >
          You can now log in with your new credentials.
        </div>
      </div>

      <Button
        className={classnames(styles.backButton)}
        onClick={() => {
          goToPage(RouteName.SignIn);
        }}
        buttonSize={ButtonSize.Medium}
        buttonType={ButtonType.Submit}
      >
        Back to Login
      </Button>
    </>
  );

  return <>{showContentView()}</>;
};

export { ResetPasswordStep2 };
